// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsLeadWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SendLeadOnApplicationSubmitRequestDto, SendLeadOnApplicationSubmitResponseDto } from '../..';

export const CappsLeadWebApiHandler_sendLeadOnApplicationSubmit_Path = '/api/web/renter/v1/sendLeadOnApplicationSubmit';

export const CappsLeadWebApiHandler_sendLeadOnApplicationSubmit = (
  postData: SendLeadOnApplicationSubmitRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendLeadOnApplicationSubmitRequestDto, SendLeadOnApplicationSubmitResponseDto>(
    {
      endpoint: CappsLeadWebApiHandler_sendLeadOnApplicationSubmit_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
